import { render } from "./modal-match-animation-modal.vue?vue&type=template&id=3806ff64&scoped=true"
import script from "./modal-match-animation-modal.vue?vue&type=script&lang=js"
export * from "./modal-match-animation-modal.vue?vue&type=script&lang=js"

import "./modal-match-animation-modal.vue?vue&type=style&index=0&id=3806ff64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3806ff64"]])

export default __exports__